export default __webpack_public_path__ + "static/media/logo1.b204e7e4.png";